import React from 'react';

export const AppsVersions = React.lazy(() => import('../AppsVersions'));
export const UploadVersion = React.lazy(() => import('./UploadVersion'));
export const ViewAppVersion = React.lazy(() => import('./ViewAppVersion/ViewAppVersion'));
export const EditVersionWithoutApk = React.lazy(() => import('./EditVersionWithoutAPK/EditVersionWithoutApk'));
export const EditVersionWithApk = React.lazy(() => import('./EditVersionWithApk/EditVersionWithApk'));

export { APPS_VERSIONS_PATH } from '../config/paths';
